import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
import { Palette } from "../../../../constants/palettes";
import { BOX_SHADOWS } from "../../../../constants/shadows";
import { applyOpacityToHexColor, darkenHex } from "../../../../util/color";
import mediaQueries from "../../../../util/mediaqueries";
import { NeutralColors } from "../../../../constants/colors";
import styled, { css } from 'styled-components';
import { HEADER_HEIGHT, MOBILE_HEADER_HEIGHT } from "../../constants";

// To ensure the `backdrop-filter` effect works in Safari, the content wrapper cannot have a height of 0.
// Therefore we give it a minimum height of 1px.
export var HEADER_BACKGROUND_OFFSET = 1;
var getTop = function getTop(_ref) {
  var fixed = _ref.fixed;
  if (!fixed) {
    return 0;
  }
  return "-".concat(HEADER_BACKGROUND_OFFSET, "px");
};
var getPaddingTop = function getPaddingTop() {
  var forMobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (_ref2) {
    var transparentBackground = _ref2.transparentBackground;
    var headerHeight = forMobile ? MOBILE_HEADER_HEIGHT : HEADER_HEIGHT;
    return transparentBackground ? "".concat(HEADER_BACKGROUND_OFFSET, "px") : "".concat(HEADER_BACKGROUND_OFFSET + headerHeight, "px");
  };
};
export var getBackgroundColor = function getBackgroundColor(_ref3) {
  var palette = _ref3.palette;
  var color = palette === Palette.Negative ? darkenHex(35, NeutralColors.Ink) : NeutralColors.White;
  var opacityRatio = palette === Palette.Negative ? 86 : 90;
  return applyOpacityToHexColor(opacityRatio, color);
};
var getHeight = function getHeight() {
  var forMobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (_ref4) {
    var contentHeight = _ref4.contentHeight,
      isMenuScrolled = _ref4.isMenuScrolled,
      transparentBackground = _ref4.transparentBackground,
      fixed = _ref4.fixed;
    if (contentHeight) {
      return contentHeight;
    }
    if (forMobile) {
      return "".concat(MOBILE_HEADER_HEIGHT, "px");
    }
    return !isMenuScrolled && transparentBackground && fixed ? 0 : "".concat(HEADER_HEIGHT, "px");
  };
};
export var menuBackgroundCommonStyles = css(["position:absolute;z-index:-1;top:", ";padding-top:", ";left:0;right:0;background-color:", ";backdrop-filter:saturate(180%) blur(20px);", ""], getTop, getPaddingTop(true), getBackgroundColor, mediaQueries.md(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding-top: ", "\n  "])), 0)), getPaddingTop(false)));
export var menuBackgroundExpandedStyles = css(["transition-delay:100ms;box-shadow:", ";"], BOX_SHADOWS.small);
export var MenuBackgroundContainer = styled.div.withConfig({
  componentId: "sc-a992jq-0"
})(["", " height:", ";transition:height 600ms cubic-bezier(0.165,0.84,0.44,1),box-shadow 600ms cubic-bezier(0.165,0.84,0.44,1);", ""], menuBackgroundCommonStyles, getHeight(true), mediaQueries.md(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: ", ";\n\n    ", "\n  "])), 0, 0)), getHeight(false), function (_ref5) {
  var isExpanded = _ref5.isExpanded;
  return isExpanded && menuBackgroundExpandedStyles;
}));